<template>
<main class="G_DisplayRowNowrap L_OrderSuccessHolder">
    <div class="G_DisplayRowNowrap L_OrderSuccessful">
        <div class="G_DisplayColumnNowrap L_OrderSuccessfulHeading G_NormalFont">
            Thank you for ordering with Tania's Sweet Treats.<br>
            Your order number is: <u>{{ OrderNumber }}</u><br>
            <div class="L_InvoiceButton" @click="DownloadInvoice()">Download Invoice</div>
            <br>
            <div class="L_InvoiceButton" @click="Home()">Home</div>
        </div>
    </div>
</main>
</template>

 
<script>
import TSTPencilLogo from '../../../assets/images/logos/TSTLogoPencil.jpeg'
import jsPDF from 'jspdf'
import 'jspdf-autotable';

export default {
    props: [
        'OrderNumber',
        'BasketItems',
        'ClientDetails'
    ],
    data() {
        return {
            TSTPencilLogo: TSTPencilLogo
        }
    },
    created() {
        if (window.localStorage.getItem("BasketItems")) this.SendOrderTelegram()
        window.localStorage.removeItem("BasketItems")
        this.$emit("UpdateBasket", [])
    },
    methods: {
        SendOrderTelegram() {
            var BasketData = []
            var TotalPrice = 0

            for (var BasketItem in this.BasketItems) {
                var BasketItemInfo = this.BasketItems[BasketItem]
                console.log(BasketItemInfo)

                var RowQty = BasketItemInfo.Qty
                var RowDesc = BasketItemInfo.Description

                TotalPrice += parseInt((BasketItemInfo.Qty * BasketItemInfo.Price))

                BasketData.push("- " + RowQty + " x " + RowDesc + " - " + "R" + (RowQty * BasketItemInfo.Price) + "%0A")
            }

            fetch("https://api.telegram.org/bot6033274730:AAEGvQCBYJEcfr7NEo_wX6OA0vkbohSnHQI/sendMessage?chat_id=-801761326&text=" +
                "Order has been placed by: " + this.ClientDetails.Name +
                "%0A" +
                "Date order: " + new Date() +
                "%0A" +
                "Order details:" +
                "%0A" +
                BasketData.toString().replaceAll(",", "") +
                "%0A" +
                "Total Price: R" + TotalPrice
            );
        },
        Home() {
            this.$emit("SetSelectedComp", "Home")
        },
        DownloadInvoice() {
            var Invoice = new jsPDF()

            var Columns = ["Quantity", "Price", "Product", "Total"]

            var BasketData = []
            var TotalPrice = 0

            for (var BasketItem in this.BasketItems) {
                var BasketItemInfo = this.BasketItems[BasketItem]

                var RowQty = BasketItemInfo.Qty
                var RowItemPrice = "R " + BasketItemInfo.Price
                var RowDesc = BasketItemInfo.Description
                var RowTotal = "R " + BasketItemInfo.Price * BasketItemInfo.Qty

                var BasketRow = []
                BasketRow.push(RowQty)
                BasketRow.push(RowItemPrice)
                BasketRow.push(RowDesc)
                BasketRow.push(RowTotal)

                BasketData.push(BasketRow)

                TotalPrice += parseInt((BasketItemInfo.Qty * BasketItemInfo.Price))
            }

            var Logo = new Image()
            Logo.src = this.TSTPencilLogo
            Invoice.addImage(Logo, 'JPG', 10, 10, 70, 50)

            Invoice.text(85, 15, "Tania's Sweet Treats")
            Invoice.text(85, 25, "Order No: #" + this.OrderNumber)
            Invoice.text(85, 35, "Thank you for your purchase!")
            Invoice.text(85, 45, "Total: R " + TotalPrice)

            Invoice.text(15, 67, "Capitec")
            Invoice.text(15, 77, "Savings")
            Invoice.text(15, 87, "Account number: 1607800940")
            Invoice.text(15, 97, "Branch code: 470010")
            Invoice.text(15, 107, "T Nel")
            Invoice.text(15, 117, "Thank you for your order!")

            Invoice.text(15, 127, "Please use your name and order number as reference.")

            Invoice.autoTable(Columns, BasketData, {
                theme: 'grid',
                startY: 135,
                styles: {
                    fontSize: 12
                },
                headStyles: {
                    fillColor: [251, 203, 235]
                }
            })

            Invoice.save("TST:#" + this.OrderNumber)
        }
    }
}
</script>

 
<style lang="scss">
@import "../../../assets/GlobalCss.scss";

.L_OrderSuccessHolder {
    width: 100%;
    height: 40rem;
    align-items: center;
    justify-content: center;
}

.L_OrderSuccessful {
    width: 70%;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.L_OrderSuccessfulHeading {
    width: 100%;
    height: 50%;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.L_InvoiceButton {
    width: 15rem;
    height: 3rem;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    color: white;
    border-radius: 0.5rem;
    background-color: #F3CBBB;
    cursor: pointer;

    @include mobile() {
        font-size: 1.5rem;
    }
}
</style>
